import Wedget from "../components/Wedget.js";

export default () => {
  return (
    <>
      <Wedget />
    </>
  );
};
